import Icon from '@ant-design/icons';

const CodeBlockSvg = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.14907 4.42466L4.53182 3.04191L3.67896 2.18906L1.44336 4.42466L3.67896 6.66027L4.53182 5.80742L3.14907 4.42466ZM6.8709 4.42466L5.48814 3.04191L6.341 2.18906L8.57663 4.42466L6.341 6.66027L5.48814 5.80742L6.8709 4.42466ZM9.53296 2.61548H13.7544C14.0874 2.61548 14.3574 2.88548 14.3574 3.21854V12.8675C14.3574 13.2005 14.0874 13.4706 13.7544 13.4706H2.89927C2.56622 13.4706 2.29621 13.2005 2.29621 12.8675V8.04305H3.50233V12.2645H13.1513V3.8216H9.53296V2.61548Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CodeBlockIcon = (props: any) => <Icon component={CodeBlockSvg} {...props} />;
